import React from 'react';
import PageLayout from '../../layout/PageLayout';
import './PrivacyPolicy.css';

const PrivacyPolicy = () => {
  return (
    <PageLayout>
      <div className="rtc-privacy-container">
        <h1 className="page-title">Privacy Policy</h1>
        <p>
          Effective Date: <span className="policy-update-date">01-Apr-2026</span>
        </p>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">1. Introduction</h2>
          <p className="rtc-privacy-text">
            RuhiTech Solutions ("we", "our", or "us") is a software services and
            technology products company based in Chennai, India. We are committed
            to protecting the privacy and confidentiality of the personal
            information you share with us. This Privacy Policy describes what
            information we collect, how we use it, how we protect it, and your
            rights regarding your data when you interact with our website,
            services, or products.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">2. Information We Collect</h2>
          <p className="rtc-privacy-text">
            We may collect the following types of personal and business
            information:
          </p>
          <ul className="rtc-privacy-text">
            <li>
              <strong>Contact Information:</strong> Name, email address, phone
              number, and company name when you reach out to us via our website,
              email, or phone.
            </li>
            <li>
              <strong>Project and Business Information:</strong> Details about
              your business requirements, project scope, and technical
              specifications shared during service engagement discussions.
            </li>
            <li>
              <strong>Billing Information:</strong> Payment details, invoicing
              information, and transaction records for services rendered or
              products purchased. We do not store full payment card details on
              our servers.
            </li>
            <li>
              <strong>Product Usage Data:</strong> If you use any RuhiTech
              Solutions products, we may collect usage data, login information,
              and feature interaction data to improve product performance.
            </li>
            <li>
              <strong>Technical Data:</strong> IP address, browser type, device
              information, and pages visited on our website, collected
              automatically via cookies and analytics tools.
            </li>
          </ul>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">3. How We Use Your Information</h2>
          <p className="rtc-privacy-text">
            The information we collect is used for the following purposes:
          </p>
          <ul className="rtc-privacy-text">
            <li>To respond to enquiries and communicate about service proposals or ongoing projects.</li>
            <li>To deliver, manage, and improve our software services and technology products.</li>
            <li>To process payments and manage billing for services and products.</li>
            <li>To send important updates, invoices, and service-related communications.</li>
            <li>To analyse website usage and improve our online presence and offerings.</li>
            <li>To comply with applicable legal and regulatory requirements.</li>
            <li>To send marketing communications about our services and products, which you may opt out of at any time.</li>
          </ul>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">4. Sharing Your Information</h2>
          <p className="rtc-privacy-text">
            RuhiTech Solutions does not sell, rent, or trade your personal
            information to third parties. We may share your information only in
            the following limited circumstances:
          </p>
          <ul className="rtc-privacy-text">
            <li>
              <strong>Trusted Service Providers:</strong> Third-party vendors
              such as cloud hosting providers, payment processors, or analytics
              tools who assist us in delivering our services, subject to strict
              confidentiality obligations.
            </li>
            <li>
              <strong>Legal Compliance:</strong> Where required by applicable
              law, court order, or governmental authority.
            </li>
            <li>
              <strong>Business Transfers:</strong> In the event of a merger,
              acquisition, or sale of assets, your information may be
              transferred as part of that transaction, with prior notice to you.
            </li>
          </ul>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">5. Data Retention</h2>
          <p className="rtc-privacy-text">
            We retain your personal information only for as long as necessary to
            fulfil the purposes outlined in this policy, to complete our service
            obligations, or as required by applicable law. Project-related data
            may be retained for a minimum of 3 years from the date of project
            completion for audit and legal compliance purposes.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">6. Data Security</h2>
          <p className="rtc-privacy-text">
            We implement industry-standard technical and organisational security
            measures to protect your personal information from unauthorised
            access, disclosure, alteration, or destruction. These measures
            include encrypted data transmission (SSL/TLS), access controls, and
            secure data storage practices. However, no method of transmission
            over the internet is 100% secure, and we cannot guarantee absolute
            security.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">7. Your Rights</h2>
          <p className="rtc-privacy-text">
            You have the following rights regarding your personal data:
          </p>
          <ul className="rtc-privacy-text">
            <li><strong>Access:</strong> Request a copy of the personal data we hold about you.</li>
            <li><strong>Correction:</strong> Request correction of inaccurate or incomplete data.</li>
            <li><strong>Deletion:</strong> Request deletion of your personal data, subject to our legal obligations.</li>
            <li><strong>Opt-Out:</strong> Unsubscribe from marketing communications at any time.</li>
            <li><strong>Data Portability:</strong> Request your data in a structured, commonly used format.</li>
          </ul>
          <p className="rtc-privacy-text">
            To exercise any of these rights, please contact us at{' '}
            <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">8. Third-Party Links</h2>
          <p className="rtc-privacy-text">
            Our website may contain links to third-party websites or services.
            We are not responsible for the privacy practices of those sites. We
            encourage you to review the privacy policy of any third-party site
            you visit.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">9. Changes to This Privacy Policy</h2>
          <p className="rtc-privacy-text">
            RuhiTech Solutions reserves the right to update this Privacy Policy
            at any time. When we do, we will revise the effective date at the
            top of this page. We encourage you to review this policy
            periodically. Your continued use of our website or services after
            any changes constitutes your acceptance of the updated policy.
          </p>
        </section>

        <section className="rtc-privacy-section">
          <h2 className="rtc-privacy-heading">10. Contact Us</h2>
          <p className="rtc-privacy-text">
            If you have any questions or concerns about this Privacy Policy,
            please contact us at:
            <br />
            <strong>RuhiTech Solutions</strong>
            <br />
            Email: <a href="mailto:contact@ruhitechsolutions.com">contact@ruhitechsolutions.com</a>
            <br />
            Phone: +91 8220343006
            <br />
            Address: #140, 1st Floor, Plaza Center, No 129, G.N. Chettey Road,
            Chennai - 600006
          </p>
        </section>
      </div>
    </PageLayout>
  );
};

export default PrivacyPolicy;
